<div [attr.aria-live]="politenessSetting" aria-atomic="true" class="sr-only">
  {{ announcement }}
</div>
